import { useEffect } from 'react'


export default (setTitle, title) => {

  useEffect(() => {
    setTitle(title)
  }, [setTitle, title])

}